import deLang from './entries/de_DE'
import enLang from './entries/en_US'

const AppLocale: { [index: string]: any } = {
  de: deLang,
  en: enLang
}

export default AppLocale
